import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { __t } from '@mssgme/shared';
import styles from './styles.scss';

export const MoreButton = ({ disabled, className, ...rest }) => (
    <span className={classNames(styles.root, { [styles.disabled]: disabled }, className)} {...rest}>
        {__t('show_more')}
    </span>
);

MoreButton.propTypes = {
    disabled: PropTypes.bool,
    className: PropTypes.string,
};
